import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-logout\"><defs><style type=\"text/css\"></style></defs><path d=\"M960.4 539.8L815.8 684.4l-48.2-48.2 60.2-60.2H512.4v-63.9h325.4l-70.2-70.2 48.2-48.2 144.6 144.6-0.7 0.8 0.7 0.7zM704.1 192.5c0-35.3-28.6-63.9-63.9-63.9H192.7c-35.3 0-63.9 28.6-63.9 63.9v639.2c0 35.3 28.6 63.9 63.9 63.9h447.5c35.3 0 63.9-28.6 63.9-63.9v-63.9H768v63.9c0 70.6-57.2 127.8-127.8 127.8H192.7c-70.6 0-127.8-57.2-127.8-127.8V192.5c0-70.6 57.2-127.8 127.8-127.8h447.5c70.6 0 127.8 57.2 127.8 127.8v127.8h-63.9V192.5z\" p-id=\"7424\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logout.svg
// module id = KvOj
// module chunks = 3